// DO NOT EDIT: autogenerated by brokkr
import { CreateIconOptions } from "./types";
export const falUserSlash: CreateIconOptions = {
  "displayName": "FALUserSlash",
  "viewBox": "0, 0, 640, 512",
  "d": "M448 128C448 57.3 390.7 0 320 0C266.1 0 219.9 33.4 201.1 80.6l26.6 21C239.2 61.4 276.1 32 320 32c53 0 96 43 96 96c0 35.9-19.7 67.2-48.9 83.7l26.6 21C426.6 209.5 448 171.2 448 128zm52.4 352L128 480c1.2-79.7 66.2-144 146.3-144l43.8 0-40.5-32-3.2 0C175.8 304 96 383.8 96 482.3c0 16.4 13.3 29.7 29.7 29.7l388.6 0c7 0 13.4-2.4 18.5-6.5L500.4 480zM25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"
};
